import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import img from "../../assets/cars-bg11.jpg";
import Background from "../CarList/Background";
import { Link } from "react-router-dom";
import { MdDoubleArrow } from "react-icons/md";
import axios from "axios";

const Index = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    // Fetch about us data from the API
    axios
      .get(`${baseURL}/about/fetchaboutUs`)
      .then((response) => {
        // Set the about us data to state
        setAboutData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching about us data:", error);
      });
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className=" ps-0 pe-0 pt-0 pb-6">
      <Background
        image={aboutData?.image ? `${baseURL}${aboutData?.image}` : img}
        name="About Us"
      />
      <div className="container mt-3 px-3 pt-4">
        <div className="my-3">
          <h3 className="d-flex flex-row accentColor align-items-baseline align-items-md-center">
            <span className="lh-0">
              <MdDoubleArrow />
            </span>
            <span className="font">
              {aboutData?.title ? aboutData?.title : "About Us"}
            </span>
          </h3>
          <p className="text-secondary py-2 fs18">
            {aboutData?.description ? aboutData?.description : "Loading..."}
          </p>
        </div>
        <div className="my-3">
          <h3 className="accentColor font my-3">
            {aboutData?.ourMissionTitle
              ? aboutData?.ourMissionTitle
              : "Our Mission"}
          </h3>
          <p className="text-secondary">
            {aboutData?.ourMissionDescription
              ? aboutData?.ourMissionDescription
              : "Loading..."}
          </p>
        </div>
        <Link to="/contactus" onClick={scrollToTop}>
          <button
            type="button"
            className="btn mt-4 mb-4 abtus-btn img-btn primaryColor"
          >
            Get in Touch
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Index;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import img from '../../assets/cars-bg11.jpg';
// import Background from '../CarList/Background';
// import { Link } from 'react-router-dom';
// import { MdDoubleArrow } from 'react-icons/md';
// import axios from 'axios';

// const Index = () => {
//     const baseURL = useSelector((state) => state?.config?.baseURL)
//     const [aboutData, setAboutData] = useState(null);

//     useEffect(() => {
//         // Fetch about us data from the API
//         axios.get(`${baseURL}/about/fetchaboutUs`)
//             .then(response => {
//                 // Set the about us data to state
//                 setAboutData(response.data.data);
//             })
//             .catch(error => {
//                 console.error('Error fetching about us data:', error);
//             });
//     }, []);

//     const scrollToTop = () => {
//         window.scrollTo(0, 0);
//     }

//     return (
//         <div className='container-fluid ps-0 pe-0 pt-0 pb-6'>
//             <Background
//                 image={aboutData?.image ? `${baseURL}${aboutData?.image}` : img}
//                 name="About Us"
//             />
//             <div className='container mt-3 px-3 pt-4'>
//                 <div className='my-3'>
//                     <h3 className='d-flex flex-row accentColor align-items-baseline align-items-md-center'>
//                         <span className='lh-0'><MdDoubleArrow /></span><span className='font'>{aboutData?.title ? aboutData?.title : "About Us"}</span>
//                     </h3>
//                     <p className='text-secondary py-2 fs18'>{aboutData?.description ? aboutData?.description : 'Loading...'}</p>
//                 </div>
//                 <div className='my-3'>
//                     <h3 className='accentColor font my-3'>{aboutData?.ourMissionTitle ? aboutData?.ourMissionTitle : 'Our Mission'}</h3>
//                     <p className='text-secondary'>{aboutData?.ourMissionDescription ? aboutData?.ourMissionDescription : 'Loading...'}</p>
//                 </div>
//                 <Link to="/contactus" onClick={scrollToTop}><button type="button" className="btn mt-4 mb-4 abtus-btn img-btn primaryColor">Get in Touch</button></Link>
//             </div>
//         </div>
//     );
// }

// export default Index;
